import { forwardRef, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', id, ...rest }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={id} className="font-serif text-sm font-semibold text-brown">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={id}
          className={`rounded-2xl border bg-paper px-4 py-3 text-sm outline-none transition-colors focus:border-terracotta ${
            error ? 'border-red-400' : 'border-cream-dark'
          } ${className}`}
          {...rest}
        />
        {error && <p className="text-xs text-red-500">{error}</p>}
      </div>
    );
  },
);
Input.displayName = 'Input';
